export const OMR_REVIEWS_URL = 'https://omr.com/en/reviews/product/fiverr?utm_source=widget&utm_medium=vendor';
export const OMR_RATING_IMAGE_SRC =
    'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/4d8d0dc8dd9e94fa24455893d8d0a7b7-1786001948387/fiverr_omr_reviews_q3_26.png';
